import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HorizontalSelectorComponent } from './components/horizontal-selector/horizontal-selector.component';
import { TranslateModule } from '@ngx-translate/core';
import { ContactFormContentComponent } from '../contact-form-content/contact-form-content.component';

@Component({
  selector: 'app-ready-for-contact-form',
  standalone: true,
  imports: [
    HorizontalSelectorComponent,
    TranslateModule,
    ContactFormContentComponent,
  ],
  templateUrl: './ready-for-contact-form.component.html',
  styleUrl: './ready-for-contact-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadyForContactFormComponent {
  protected expanded = false;
  protected isPrivacyChecked = false;
  protected selectedCategory = '';

  protected setExpanded(param: any) {
    this.expanded = param;
  }
}
